import { Button } from '@veneer/core';
import { primitives } from '@veneer/primitives';
import * as VeneerPrimitives from '@components/styles/primitives';
import { minTablet } from '../../../GlobalStylesVisid';
import styled from 'styled-components';

const { size3, size6, cornerRadius2 } = primitives.layout;
const { gray3 } = primitives.color;
const { electricBlue7 } = VeneerPrimitives.color;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size6}px;
  margin-top: 40px;
`;

export const Title = styled.span.attrs({ className: 'subtitle-regular' })``;

export const ButtonsContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: ${size3}px;

  ${minTablet} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
export const PlanButton = styled(Button)<{ selected?: boolean }>`
  width: 100%;
  height: 36px;
  background-color: ${({ selected }) =>
    selected ? electricBlue7 : 'transparent'} !important;
  color: ${({ selected }) =>
    selected ? primitives.color.white : 'initial'} !important;
  border: 1px solid ${({ selected }) => (selected ? electricBlue7 : gray3)} !important;
  border-radius: ${cornerRadius2}px !important;

  &:hover {
    background-color: ${({ selected }) =>
      selected ? electricBlue7 : gray3} !important;
    color: ${({ selected }) =>
      selected ? primitives.color.white : 'initial'} !important;
  }
`;
